<template>
  <div class="app flex-row align-items-center" >
    <div class="container">
      Logout 한글
    </div>
  </div>
</template>

<script>import App from './app.js'; export default Object.assign({}, App);</script>
